$('.tego-numeroAgpm').mask("0000000-0-A");
